import React, { useState } from 'react';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import AreaTipoDivergenciaEnum from '../../../AreaTipoDivergenciaEnum';
import FinalStepTemplate, { useBuildDefaultInfoComponent } from '../../../template/FinalStepTemplate';
import useBuildSubmitHandler from '../../../template/UseBuildSubmitHandler';
import { createBackHandler } from '../../../template/utils';
import TipoDivergenciasInfoKey from '../../../TipoDivergenciasInfoKey.';
import TipoDivergenciasKey from '../../../TipoDivergenciasKey';
import { TipoDivergenciaComponent, TipoDivergenciaComponentProps } from '../../../TiposDeDivergencias';
import AjusteDeGradeDoPedido from './AjusteDeGradeDoPedido';
import LabelValueWithSubtitle from '../../../components/LabelValueWithSubtitle';

export interface PayloadProblemProps extends TipoDivergenciaComponentProps {
  payload: {
    valoresGrade: Record<string, number>;
    nomeTecido: string;
  };
}

const AjusteDeGradeDoPedidoFinalStep: TipoDivergenciaComponent<PayloadProblemProps> = ({
  onSetStep,
  onBack,
  payload,
}) => {
  const onBackHandler = createBackHandler(onBack, AjusteDeGradeDoPedido);

  const listaGrades = Object.entries(payload.valoresGrade || {});

  const [tamanhoSelecionado, setTamanhoSelecionado] = useState(
    listaGrades.length > 0 ? listaGrades[0][0] : ''
  );

  const infoComponents = [
    ...useBuildDefaultInfoComponent(
      AreaTipoDivergenciaEnum.CONTROLE_PCP,
      'Ajuste de Grade do Pedido'
    ),
    <LabelValueWithSubtitle
      key="tecido-grade"
      label='Tecido de Referência'
      value={payload.nomeTecido || 'Não informado'}
      subtitle={''}
    />,
    <div key="select-grade" style={{ marginTop: '16px', minWidth: '200px' }}>
      <FormControl variant="outlined" fullWidth size="small">
        <InputLabel id="label-grade-alterada">Ver Grade Alterada</InputLabel>
        <Select
          labelId="label-grade-alterada"
          id="select-grade-alterada"
          value={tamanhoSelecionado}
          onChange={(e) => setTamanhoSelecionado(e.target.value as string)}
          label="Ver Grade Alterada"
        >
          {listaGrades.map(([tamanho, quantidade]) => (
            <MenuItem key={tamanho} value={tamanho}>
              Tamanho {tamanho}: {quantidade} un.
            </MenuItem>
          ))}
          {listaGrades.length === 0 && (
            <MenuItem disabled value="">
              Nenhuma alteração realizada
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </div>,
  ];

  const key = TipoDivergenciasKey.AJUSTE_DE_GRADE_DO_PEDIDO;
  const {
    loadingSave,
    loadingTipoDivergencia,
    handleSubmit,
  } = useBuildSubmitHandler(key, onSetStep);

  return (
    <FinalStepTemplate
      loading={loadingSave || loadingTipoDivergencia}
      onBack={onBackHandler}
      onSetStep={(step) => {

        const linhaTecido = {
          tipo: TipoDivergenciasInfoKey.TECIDO_TAMANHO_GRADE,
          value: payload.nomeTecido,
        };

        const linhasGradeUnificadas = listaGrades.map(([tamanho, quantidade]) => ({
          tipo: TipoDivergenciasInfoKey.TAMANHO_GRADE,
          value: `${tamanho}: ${quantidade}`,
          adicionalInfo: [],
        }));

        const payloadEnvio = [linhaTecido, ...linhasGradeUnificadas];

        handleSubmit(step, payloadEnvio);
      }}
      progressValue={90}
      stepNumber={'3'}
      infoComponents={infoComponents}
    />
  );
};

export default AjusteDeGradeDoPedidoFinalStep;